/** @griffel:css-start [d] null **/
.f1pbl6dw{font-variant-numeric:tabular-nums;}
.fz5stix{white-space:nowrap;}
/** @griffel:css-end **/